import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 w-full bg-reset-black/95 backdrop-blur-sm border-b border-reset-gold/20 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-2xl font-bold text-white tracking-tight"
              translate="no"
            >
              <span className="text-reset-gold" translate="no">Tecno</span><span translate="no">abogado</span>
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <button
              onClick={() => scrollToSection('autores')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              Autores
            </button>
            <button
              onClick={() => scrollToSection('problema')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              El problema
            </button>
            <button
              onClick={() => scrollToSection('solucion')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              La solución
            </button>
            <button
              onClick={() => scrollToSection('implementacion')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              Implementación
            </button>
            <button
              onClick={() => scrollToSection('continuidad')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              Continuidad
            </button>
            <button
              onClick={() => scrollToSection('libros')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              Libros
            </button>
            <button
              onClick={() => scrollToSection('recursos')}
              className="text-gray-300 hover:text-reset-gold transition-colors text-sm"
            >
              Recursos
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-reset-gold hover:bg-reset-gold-light text-black px-5 py-2 font-semibold transition-all text-sm"
            >
              Contacto
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-reset-gold"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-reset-dark border-t border-reset-gold/20">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <button
              onClick={() => scrollToSection('autores')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              Autores
            </button>
            <button
              onClick={() => scrollToSection('problema')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              El problema
            </button>
            <button
              onClick={() => scrollToSection('solucion')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              La solución
            </button>
            <button
              onClick={() => scrollToSection('implementacion')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              Implementación
            </button>
            <button
              onClick={() => scrollToSection('continuidad')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              Continuidad
            </button>
            <button
              onClick={() => scrollToSection('libros')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              Libros
            </button>
            <button
              onClick={() => scrollToSection('recursos')}
              className="block w-full text-left px-3 py-2 text-gray-300 hover:text-reset-gold hover:bg-reset-gray transition-colors"
            >
              Recursos
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="block w-full text-left px-3 py-2 bg-reset-gold text-black font-semibold mt-2"
            >
              Contacto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;